import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-invoice-list-page',
  templateUrl: './invoice-list-page.component.html',
  styleUrls: ['./invoice-list-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InvoiceListPageComponent {

}
